<template>
  <v-footer
      inset
      fixed
      app
      padless
      elevation="2"
      class="d-flex pa-1 white"
    >
      <a href="https://mydomx.eu/wp-content/uploads/2023/07/Terms_DOMX_for_Business.pdf" target="_blank" class="pa-2 textColor2--text text-body-2">{{ $t('termsAndConditions') }}</a>
      <a href="https://mydomx.eu/DOMX_Privacy_Policy.pdf" target="_blank" class="pa-2 textColor2--text text-body-2">{{ $t('privacyPolicy') }}</a>
      <a href="https://domx.io/contact/" target="_blank" class="pa-2 textColor2--text text-body-2">{{ $t('corporateInformation') }}</a>
      

      <a :href="distributorLink" target="_blank" class="pa-2 textColor2--text text-body-2 ml-auto"> {{ !officialDistributor ? $t('official_distributor') : '' }} </a>
      <a v-if="distributorLogoLink" :href="distributorLink" target="_blank" class="pa-2 textColor2--text text-body-2">
          <v-img 
          max-width="120" 
          contain
          class="logo"
          :src="distributorLogoLink"
          />   
      </a>
      <div class="pa-2 textColor2--text text-body-2 ml-auto"  tile>{{ $t('copyright') }}</div>
    </v-footer>
</template>

<script lang="ts">
import config from "../../config";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import {  companyModule } from "@/store/modules/store-accessor"
import KeycloakSession from '@/helpers/keycloak-session'

@Component
export default class Footer extends Vue {
  links = [
    {
      text: "Official Distributor Gas Technic",
      link: "https://gastechnic.gr/",
    },
    { text: "domX", link: "https://mydomx.eu/" },
    // { text: "Blog", link: "https://flatlogic.com/blog" },
  ];

  get distributorLogoLink() {
    // return companyModule.company.distributor_logo_link;
    if(this.isDistributor) {
      return companyModule.company.company_logo_link;
    }
    else {
      return companyModule.company.distributor_logo_link;
    }
  }

  get officialDistributor() {
    // return companyModule.company.distributor_logo_link;
    if(this.isDistributor) {
      //This is a hack...for demos...this should just return true
       if (companyModule.company.email == 'info@domx.io') {
        return true;
       }
    }
    return false;
  }

  get distributorLink() {
    // return companyModule.company.distributor_link;
    if(this.isDistributor) {
      return '#'
    }
    else {
      return companyModule.company.distributor_link;
    }
  }

  get kcSession() {
    return new KeycloakSession()
  }

  get isDistributor() {
    return this.kcSession.userHasRole('distributor');
  }

  get isTechnicianCompany () {
    return this.kcSession.userHasRole('technician_company');
  }

  logo:any = require("@/assets/img/new_logo_domX.png");

  text_color = config.light.textColor;
  icons = [
    {
      icon: "mdi-facebook",
      link: "https://www.facebook.com/GasTechnic/",
    },
    {
      icon: "mdi-instagram",
      link: "https://www.instagram.com/gastechnic/",
    },
    // { icon: "mdi-twitter", link: "https://www.facebook.com/flatlogic" },
    // { icon: "mdi-github", link: "https://github.com/flatlogic/" },
  ];
}
</script>

<style lang="scss">
@import "../../styles/app";
.v-footer {
  a:link {
        text-decoration: none;
  }

  a:visited {
        text-decoration: none;
  }

  a:hover {
        text-decoration: none;
  }

  a:active {
        text-decoration: none;
  }
}
</style>
